import styled from 'styled-components'
import { Dropdown } from 'semantic-ui-react'
import PhoneInput from 'react-phone-number-input'

export const SubmitButton = styled.button`
  color: #fff;
  height: 40px;
  margin: auto;
  display: block;
  font-size: 16px;
  width: 220px;
  border-radius: 28px;
  background-color: #2fc2be;
  border: 1px solid #2fc2be;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);


  :hover {
    cursor: pointer;
  }

  :focus {
    outline: none;
    box-shadow: 0px 1px 4pt 0pt #6da3f8;
  }
`

export const OpdFormStyle = styled.div`
  max-width: 700px;
  min-height: 736px;
  margin: auto;
  margin-top: 60px;
  background: #fff;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  text-align: left;
  padding: 20px 4%;
  a {
    padding: 0 5px;
  }
  input {
    border: 1px solid #bdbdbd;
    padding: 10px;
    font-size: 14px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
  .information-form {
    max-width: 405px;
    display: block;
    margin: auto;
  }
  .flex {
    display: flex;
    flex-wrap: wrap;
  }
  .input-title {
    margin: 5px;
    font-size: 16px;
  }
  .form-row {
    margin: 24px 0;
  }
  .form-header {
    font-size: 24px;
  }
  .term-text {
    font-size: 13px;
  }
  .term-checkbox {
    margin: 0 5px;
  }
  .col-2 {
    width: 100%;
    max-width: 186px;
    margin-bottom: 10px;
    margin-right: 16px;
  }
  .col-3 {
    width: 100%;
    max-width: 380px;
    margin-bottom: 10px;
    margin-right: 16px;
  }
  .summary {
    max-width: 500px;
    padding: 25px 0;
  }
  .summary-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-bottom: 1px solid #ededed;
  }
  .summary-col {
    width: 245px;
    height: 55px;
    padding: 18px 0;
    text-align: left;
    font-size: 16px;
    font-weight: lighter;
  }
  .summary-col-name {
    width: 245px;
    height: 55px;
    padding: 18px 0;
    text-align: left;
    font-size: 16px;
  }
  textarea {
    width: 100%;
    height: 88px;
    margin: 18px 0;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dadada;
    font-size: 16px;
    padding: 8px;
    font-weight: 300;
    box-sizing: border-box;
    box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.03);
  }
  .summary-bt-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .summary-next-bt {
    margin: 0;
  }
  .summary-back-bt {
    margin: 0 20px 10px 0;
    background: #fff;
    color: #2fc2be;
  }
  .error-text {
    padding: 8px;
    font-size: 13px;
    text-align: center;
    color: red;
  }
`

export const BirthDateInput = styled(Dropdown)`
  &&& {
    max-width: 116px;
    margin-bottom: 10px;
    margin-right: 16px;
    border: 1px solid #bdbdbd !important;
  }
`

export const InputPhoneCustomStyle = styled(PhoneInput)`
  &&& {
    height: 35px;
    max-width: 380px;
    border: 1px solid #bdbdbd;
    padding: 0 10px;
    font-size: 14px;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.05);
    border-radius: 4px;

    input{
      height: 30px;
      border: none;
      box-shadow:none;
    }
  }
`
export const CustomRadioButton = styled.div`
  display: flex;
  padding: 5px 10px;
  label {
    width: 130px;
  }

  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: black;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 19px;
    height: 19px;
    border: 1px solid #ddd;
    border-radius: 100%;
    background: #fff;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: "";
    width: 21px;
    height: 21px;
    border: 6px solid #2fc2be;
    position: absolute;
    box-sizing: border-box;
    top: 0;
    left: 0;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`
